var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioPauseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.20312 13.8896H3.14746C3.9209 13.8896 4.33984 13.4707 4.33984 12.6865V1.19238C4.33984 0.375977 3.9209 0 3.14746 0H1.20312C0.418945 0 0 0.418945 0 1.19238V12.6865C0 13.4707 0.418945 13.8896 1.20312 13.8896ZM7.4873 13.8896H9.43164C10.2051 13.8896 10.624 13.4707 10.624 12.6865V1.19238C10.624 0.375977 10.2051 0 9.43164 0H7.4873C6.70312 0 6.28418 0.418945 6.28418 1.19238V12.6865C6.28418 13.4707 6.70312 13.8896 7.4873 13.8896Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPauseIcon);
export default __webpack_public_path__ + "static/media/audio_pause_icon.6edd2e24d7e2450d29285fec8657e3c2.svg";
export { ForwardRef as ReactComponent };